import { pickConstants } from '../_constants';

export function picks(state = {}, action) {
//	console.log('picks reducer was called with state', state, 'and action', action)
    switch (action.type) {
        case pickConstants.GET_PICKS_SUCCESS:
            return {
							items: action.picks,
							isLoading: false
						};
        case pickConstants.GET_PICKS_REQUEST:
            return {isLoading: true};
        case pickConstants.GET_PICKS_FAILURE:
            return {
							hasErrored: action.hasErrored,
							isLoading: false
						};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/picks.js